// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ChatInterface — split-screen layout. Whole interface is black & white
   (only the logo/wordmark are excluded, styled elsewhere) — OutputArea.css
   and LeftPanel.css/RightPanel.css already carry the black/white palette,
   so no left/right-specific overrides are needed here anymore. */

.chat-interface {
  display: flex;
  width: 100%;
  height: 100%;
  background: #000000;
  overflow: hidden;
}

.interface-divider {
  width: 1px;
  background: #333333;
  flex-shrink: 0;
}

.interface-side {
  flex: 1 1;
  min-width: 0;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: thin;
  scrollbar-color: #444444 transparent;
}

.interface-side::-webkit-scrollbar { width: 5px; }
.interface-side::-webkit-scrollbar-track { background: transparent; }
.interface-side::-webkit-scrollbar-thumb { background: #444444; border-radius: 3px; }
.interface-side::-webkit-scrollbar-thumb:hover { background: #ffffff; }

.side-content {
  display: flex;
  flex-direction: column;
  padding: 28px 24px;
  gap: 20px;
  height: 100%;
  box-sizing: border-box;
}

/* Panel component (LeftPanel / RightPanel) fills available height */
.interface-left .side-content > :first-child {
  flex: 1 1;
  min-height: 0;
}

/* Output always pushed to the same level on both sides */
.output-wrapper {
  flex-shrink: 0;
  margin-top: auto;
}

/* Mobile */
@media (max-width: 768px) {
  .chat-interface { flex-direction: column; }
  .interface-divider { width: 100%; height: 1px; }
  .side-content { padding: 18px 16px; }
}
`, "",{"version":3,"sources":["webpack://./src/components/ChatInterface.css"],"names":[],"mappings":"AAAA;;;iEAGiE;;AAEjE;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA,qCAAqC,UAAU,EAAE;AACjD,2CAA2C,uBAAuB,EAAE;AACpE,2CAA2C,mBAAmB,EAAE,kBAAkB,EAAE;AACpF,iDAAiD,mBAAmB,EAAE;;AAEtE;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,sBAAsB;AACxB;;AAEA,oEAAoE;AACpE;EACE,SAAO;EACP,aAAa;AACf;;AAEA,yDAAyD;AACzD;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,kBAAkB,sBAAsB,EAAE;EAC1C,qBAAqB,WAAW,EAAE,WAAW,EAAE;EAC/C,gBAAgB,kBAAkB,EAAE;AACtC","sourcesContent":["/* ChatInterface — split-screen layout. Whole interface is black & white\n   (only the logo/wordmark are excluded, styled elsewhere) — OutputArea.css\n   and LeftPanel.css/RightPanel.css already carry the black/white palette,\n   so no left/right-specific overrides are needed here anymore. */\n\n.chat-interface {\n  display: flex;\n  width: 100%;\n  height: 100%;\n  background: #000000;\n  overflow: hidden;\n}\n\n.interface-divider {\n  width: 1px;\n  background: #333333;\n  flex-shrink: 0;\n}\n\n.interface-side {\n  flex: 1;\n  min-width: 0;\n  overflow-y: auto;\n  overflow-x: hidden;\n  scrollbar-width: thin;\n  scrollbar-color: #444444 transparent;\n}\n\n.interface-side::-webkit-scrollbar { width: 5px; }\n.interface-side::-webkit-scrollbar-track { background: transparent; }\n.interface-side::-webkit-scrollbar-thumb { background: #444444; border-radius: 3px; }\n.interface-side::-webkit-scrollbar-thumb:hover { background: #ffffff; }\n\n.side-content {\n  display: flex;\n  flex-direction: column;\n  padding: 28px 24px;\n  gap: 20px;\n  height: 100%;\n  box-sizing: border-box;\n}\n\n/* Panel component (LeftPanel / RightPanel) fills available height */\n.interface-left .side-content > :first-child {\n  flex: 1;\n  min-height: 0;\n}\n\n/* Output always pushed to the same level on both sides */\n.output-wrapper {\n  flex-shrink: 0;\n  margin-top: auto;\n}\n\n/* Mobile */\n@media (max-width: 768px) {\n  .chat-interface { flex-direction: column; }\n  .interface-divider { width: 100%; height: 1px; }\n  .side-content { padding: 18px 16px; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
